import {useState, useEffect} from 'react';
import {graphql, forecastFetchQuery} from '../../../graphql/forecastRelay';
import type {useForecastProjectsQuery$data} from './__generated__/useForecastProjectsQuery.graphql';

const ForecastProjectsQueryDoc = graphql`
	query useForecastProjectsQuery {
		viewer {
			projects(first: 200) {
				edges {
					node {
						id
						name
					}
				}
			}
		}
	}
`;

export interface ForecastProjectOption {
	id: string;
	name: string;
}

/** Loads the viewer's Forecast projects once, for the create-task project picker. */
export function useForecastProjects() {
	const [projects, setProjects] = useState<ForecastProjectOption[]>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		let cancelled = false;
		setLoading(true);
		forecastFetchQuery(ForecastProjectsQueryDoc, {})
			.then(data => {
				if (cancelled) return;
				const typed = data as useForecastProjectsQuery$data | null;
				setProjects(
					(typed?.viewer?.projects?.edges ?? []).flatMap(edge =>
						edge?.node && edge.node.name ? [{id: edge.node.id, name: edge.node.name}] : []
					)
				);
			})
			.catch(() => {
				if (!cancelled) setProjects([]);
			})
			.finally(() => {
				if (!cancelled) setLoading(false);
			});
		return () => {
			cancelled = true;
		};
	}, []);

	return {projects, loading};
}
